<template>
    <div class="w-full h-screen relative overflow-hidden">
        <!-- alert -->
        <div :class="erreurAlert ? 'translate-x-0' : 'translate-x-[110%]'"
            class="transition md:max-w-[25%] w-min max-w-[80%] duration-1000 absolute top-10 right-2 z-[100]">
            <div class="h-10"></div>
            <div class=" px-5 w-full py-3 space-x-1  flex items-center justify-center bg-red-500  rounded-md z-[100]">
                <svg class="h-12" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                    viewBox="0 0 208 208" version="1.1">
                    <g id="surface1">
                        <path style=" stroke:none;fill-rule:nonzero;fill:#FFFFFF;fill-opacity:1;"
                            d="M 199.246094 158.621094 L 120.027344 21.421875 C 110.332031 4.648438 94.515625 4.648438 84.820313 21.421875 L 5.601563 158.621094 C -4.09375 175.394531 3.847656 189.089844 23.207031 189.089844 L 181.644531 189.089844 C 201 189.089844 208.910156 175.394531 199.246094 158.621094 Z M 91.53125 60.351563 C 94.390625 57.273438 97.992188 55.734375 102.425781 55.734375 C 106.855469 55.734375 110.457031 57.246094 113.320313 60.292969 C 116.121094 63.308594 117.566406 67.125 117.566406 71.710938 C 117.566406 75.617188 111.65625 104.546875 109.6875 125.566406 L 95.4375 125.566406 C 93.714844 104.546875 87.28125 75.617188 87.28125 71.710938 C 87.28125 67.183594 88.730469 63.398438 91.53125 60.351563 Z M 113.105469 160.375 C 110.117188 163.269531 106.546875 164.746094 102.425781 164.746094 C 98.300781 164.746094 94.730469 163.269531 91.746094 160.375 C 88.757813 157.453125 87.28125 153.945313 87.28125 149.789063 C 87.28125 145.664063 88.757813 142.09375 91.746094 139.109375 C 94.730469 136.125 98.300781 134.648438 102.425781 134.648438 C 106.546875 134.648438 110.117188 136.125 113.105469 139.109375 C 116.089844 142.09375 117.566406 145.664063 117.566406 149.789063 C 117.566406 153.945313 116.089844 157.453125 113.105469 160.375 Z " />
                    </g>
                </svg>
                <p class="text-white text-center w-max">{{ messageErreurAlert }}</p>
            </div>
        </div>

        <!-- success -->
        <div :class="successAlert ? 'translate-x-0' : 'translate-x-[120%]'"
            class="transition md:max-w-[25%] w-min max-w-[80%] duration-1000 absolute top-10 right-2 z-[100]">
            <div class="h-10"></div>
            <div class=" px-5 w-full py-3 space-x-2 h-16 flex items-center justify-center bg-green-500  rounded-md z-[100]">
                <img class="h-8 object-contain" src="/icons/checkwhite.png" alt="" srcset="">
                <p class="text-white w-max text-center first-letter:uppercase">{{ messageSuccessAlert }}</p>
            </div>
        </div>
        <div v-if="loadingScreen" class="w-full h-screen flex items-center bg-white  absolute z-[60]">
            <div class=" mx-auto relative flex items-center">
                <div id="page">
                    <div id="container">
                        <div id="ring"></div>
                        <div id="ring"></div>
                        <div id="ring"></div>
                        <div id="ring"></div>
                        <img class="h-20 mx-auto" src="/logo/mel_logo_all_fond.png" alt="" srcset="">
                    </div>
                </div>
            </div>
        </div>

        <div v-if="showPushPermissionModal"
            class="fixed inset-0 z-[90] flex items-center justify-center bg-black/40 px-4">
            <div class="w-full max-w-sm rounded-xl bg-white p-6 text-center shadow-2xl">
                <div class="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-orange-100">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                        fill="none" stroke="currentColor" stroke-width="2"
                        stroke-linecap="round" stroke-linejoin="round"
                        class="h-7 w-7 text-orange-500">
                        <path d="M18 8a6 6 0 0 0-12 0c0 7-3 7-3 7h18s-3 0-3-7" />
                        <path d="M13.73 21a2 2 0 0 1-3.46 0" />
                    </svg>
                </div>
                <h2 class="mt-4 text-lg font-semibold text-gray-900">Recevoir les alertes caisse</h2>
                <p class="mt-2 text-sm leading-relaxed text-gray-600">
                    Activez les notifications pour voir les nouvelles commandes et les alertes du point relais meme quand l'application est fermee.
                </p>
                <div class="mt-5 flex flex-col gap-3">
                    <button type="button" @click="activatePushNotifications" :disabled="pushPermissionLoading"
                        class="rounded-lg bg-orange-500 px-4 py-3 text-sm font-semibold text-white transition hover:bg-orange-600 disabled:bg-orange-300">
                        {{ pushPermissionLoading ? 'Activation...' : 'Activer les notifications' }}
                    </button>
                    <button type="button" @click="dismissPushPermissionModal"
                        class="rounded-lg border border-gray-200 px-4 py-3 text-sm font-semibold text-gray-600 hover:bg-gray-50">
                        Plus tard
                    </button>
                </div>
            </div>
        </div>

        <div v-if="showDetail" class="w-full h-screen flex justify-center items-center absolute z-[50]">
            <div class="w-full h-full relative ">
                <div class="w-[80%] h-[90%] rounded-lg bg-white shadow-md absolute  inset-0  m-auto shadow-black">
                    <detail-page :articleSelect="this.article"></detail-page>
                </div>
                <div @click="showDetail = !showDetail" class="w-full h-full "></div>
            </div>
        </div>

        <div v-if="showRecu" class="w-full h-screen  flex justify-center items-center backdrop-blur absolute z-[50]">
            <div class="w-full h-full relative  ">
                <div class="inset-0 m-auto rounded-lg  w-min h-min shadow-xl absolute    ">
                    <facture-page :recuSelect="this.factureRecu"></facture-page>
                </div>
                <div @click="showRecu = !showRecu" class="w-full  h-full "></div>
            </div>
        </div>

        <!-- showCanceledCommandeRecuperation -->
        <div v-if="showCanceledCommandeRecuperation" class="w-full h-screen  flex justify-center items-center backdrop-blur absolute z-[50]">
            <div class="w-full h-full relative  ">
                <div class="inset-0 m-auto rounded-lg  w-min h-min shadow-xl absolute    ">
                    <div
                        class="w-[90vw] xl:w-[80vh] py-9 bg-white space-y-16 flex-col shadow rounded-lg flex justify-center items-center">
                        <div class="text-xl text-center font-semibold px-4">
                            <p>{{ $t('vousetessurlepointdannulerlacommande') }} <br> 
                            <span class="text-orange-500">{{facture.matricule }}</span> </p>
                        </div>
                        <form @submit.prevent="annulationCommandeRecuperation(facture)" class="w-[95%] space-y-4">
                            <div class=" w-full  grid grid-cols-2 gap-3">
                                <div class="border-2 border-dashed border-gray-300 w-full h-44 relative group focus-within:border-[#FF9900]">
                                    <textarea required v-model="formAnnulation.raison_fr" class="h-full flex flex-col justify-center items-center absolute top-0 right-0 left-0 m-auto p-1 outline-none" :placeholder="$t('entrerlaraisondelannulationenfrancais')"></textarea>
                                </div>
                                <div class="border-2 border-dashed border-gray-300 w-full h-full relative group focus-within:border-[#FF9900]">
                                    <textarea required v-model="formAnnulation.raison_en" class="h-full flex flex-col justify-center items-center absolute top-0 right-0 left-0 m-auto p-1 outline-none" :placeholder="$t('entrerlaraisondelannulationenanglais')"></textarea>
                                </div>
                            </div>
                            <div class="w-full flex items-center justify-center gap-3">
                                <button v-if="!loadingAnnulationCommandeRecuperation" type="submit"
                                    class="py-2 px-5 bg-green-500 text-white rounded">{{$t('validez')}}</button>
                                <button v-if="!loadingAnnulationCommandeRecuperation" type="button" @click="closeReceive"
                                    class="py-2 px-5 bg-red-500 text-white rounded">{{$t('annuler')}}</button>
                                <div v-if="loadingAnnulationCommandeRecuperation == true"
                                    class="animate-spin ease-linear rounded-full w-10 h-10 border-t-2 border-b-2 border-orange-500 ml-3">
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div @click="showCanceledCommandeRecuperation = !showCanceledCommandeRecuperation" class="w-full  h-full "></div>
            </div>
        </div>

        <div v-if="showReceive" class="w-full h-screen  flex justify-center items-center backdrop-blur absolute z-[50]">
            <div class="w-full h-full relative  ">
                <div class="inset-0 m-auto rounded-lg  w-min h-min shadow-xl absolute    ">
                    <form @submit.prevent="recuperationCommande"
                        class="w-[90vw] xl:w-[80vh] py-9 bg-white space-y-16 flex-col shadow rounded-lg flex justify-center items-center">
                        <div class="text-xl text-center font-semibold px-4">
                            <p>{{ $t('Avezvousrecularticledelacommande') }} <br> <span class="text-orange-500">{{
                                facture.matricule }}</span> ? </p>
                        </div>
                        <div class="w-[95%] grid grid-cols-2 gap-3">
                            <div class="border border-dashed border-gray-500 w-full relative">
                                <input ref="vendeurVersoInput" @change="imgVendeurVerso" type="file" accept="image/jpeg,image/jpg,image/png,image/gif,image/webp" capture="environment"
                                    class="cursor-pointer relative block opacity-0 w-full h-full p-20 z-50">
                                <div v-if="Venverso.length == 0"
                                    class="text-center h-full flex flex-col justify-center items-center absolute top-0 right-0 left-0 m-auto">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                        class="w-10 h-10 text-gray-500">
                                        <path fill-rule="evenodd"
                                            d="M1 5.25A2.25 2.25 0 013.25 3h13.5A2.25 2.25 0 0119 5.25v9.5A2.25 2.25 0 0116.75 17H3.25A2.25 2.25 0 011 14.75v-9.5zm1.5 5.81v3.69c0 .414.336.75.75.75h13.5a.75.75 0 00.75-.75v-2.69l-2.22-2.219a.75.75 0 00-1.06 0l-1.91 1.909.47.47a.75.75 0 11-1.06 1.06L6.53 8.091a.75.75 0 00-1.06 0l-2.97 2.97zM12 7a1 1 0 11-2 0 1 1 0 012 0z"
                                            clip-rule="evenodd" />
                                    </svg>

                                    <h5 class="text-gray-500">
                                        {{ $t('versodelacniduvendeur') }}
                                    </h5>
                                    <p class="text-xs text-gray-400 mt-1">{{ $t('taillecni') }}</p>
                                </div>
                                <div v-if="Venverso.length != 0"
                                    class="text-center h-full flex justify-center items-center absolute top-0 right-0 left-0 m-auto">
                                    <img :src="Venverso" class="h-full w-full object-cover object-center" alt="">
                                    <span class="absolute bottom-2 rounded bg-black/70 px-3 py-1 text-xs text-white">{{ $t('remplacerimage') }}</span>
                                </div>
                            </div>

                            <div class="border border-dashed border-gray-500 w-full relative">
                                <input ref="vendeurRectoInput" @change="imgVendeurRecto" type="file" accept="image/jpeg,image/jpg,image/png,image/gif,image/webp" capture="environment" 
                                    class="cursor-pointer relative block opacity-0 w-full h-full p-20 z-50">
                                <div v-if="Venrecto.length == 0"
                                    class="text-center h-full flex flex-col justify-center items-center absolute top-0 right-0 left-0 m-auto">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                        class="w-10 h-10 text-gray-500">
                                        <path fill-rule="evenodd"
                                            d="M1 5.25A2.25 2.25 0 013.25 3h13.5A2.25 2.25 0 0119 5.25v9.5A2.25 2.25 0 0116.75 17H3.25A2.25 2.25 0 011 14.75v-9.5zm1.5 5.81v3.69c0 .414.336.75.75.75h13.5a.75.75 0 00.75-.75v-2.69l-2.22-2.219a.75.75 0 00-1.06 0l-1.91 1.909.47.47a.75.75 0 11-1.06 1.06L6.53 8.091a.75.75 0 00-1.06 0l-2.97 2.97zM12 7a1 1 0 11-2 0 1 1 0 012 0z"
                                            clip-rule="evenodd" />
                                    </svg>

                                    <h5 class="text-gray-500">
                                        {{ $t('rectodelacniduvendeur') }}
                                    </h5>
                                    <p class="text-xs text-gray-400 mt-1">{{ $t('taillecni') }}</p>

                                </div>
                                <div v-if="Venrecto.length != 0"
                                    class="text-center h-full flex justify-center items-center absolute top-0 right-0 left-0 m-auto">
                                    <img :src="Venrecto" class="h-full w-full object-cover object-center" alt="">
                                    <span class="absolute bottom-2 rounded bg-black/70 px-3 py-1 text-xs text-white">{{ $t('remplacerimage') }}</span>
                                </div>
                            </div>
                        </div>
                        <p v-if="!canSubmitVendorCni" class="w-[95%] text-center text-sm text-red-500">{{ $t('messageerrorrectoversovendeur') }}</p>
                        <div class="space-x-1 flex justify-around items-center">
                            <button v-if="!loadingRecuperation" type="submit" :disabled="!canSubmitVendorCni"
                                :class="['py-2 px-5 text-white rounded', canSubmitVendorCni ? 'bg-green-500' : 'bg-gray-300 cursor-not-allowed']">{{$t('validez')}}</button>
                            <button v-if="!loadingRecuperation" @click="closeReceive" type="button"
                                class="py-2 px-5 bg-red-500 text-white rounded">{{$t('annuler')}}</button>
                            <div v-if="loadingRecuperation == true"
                                class="animate-spin ease-linear rounded-full w-10 h-10 border-t-2 border-b-2 border-orange-500 ml-3">
                            </div>
                        </div>
                    </form>
                </div>
                <div @click="closeReceive" class="w-full  h-full "></div>
            </div>
        </div>
        <div v-if="showValidate" class="w-full h-screen flex justify-center items-center backdrop-blur absolute z-[50]">
            <div class="w-full h-full relative  ">
                <div class="inset-0 m-auto rounded-lg  w-min h-min shadow-xl absolute    ">
                    <div
                        class=" w-[90vw] xl:w-[80vh] py-8 bg-white space-y-6 flex-col shadow rounded-lg flex justify-center items-center">
                        <div class="text-xl text-center font-semibold px-4">
                            <p>{{ $t('voulezvousvalisezcommande') }} <br> <span class="text-orange-500">{{
                                facture.matricule }}</span> ? </p>
                        </div>
                        <div class="w-[95%] grid grid-cols-2 gap-3">
                            <div class="border border-dashed border-gray-500 w-full relative">
                                <input ref="acheteurVersoInput" @change="imgAcheterVerso" type="file" accept="image/jpeg,image/jpg,image/png,image/gif,image/webp" capture="environment"
                                    class="cursor-pointer relative block opacity-0 w-full h-full p-20 z-50">
                                <div v-if="previewverso.length == 0"
                                    class="text-center h-full flex flex-col justify-center items-center absolute top-0 right-0 left-0 m-auto">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                        class="w-10 h-10 text-gray-500">
                                        <path fill-rule="evenodd"
                                            d="M1 5.25A2.25 2.25 0 013.25 3h13.5A2.25 2.25 0 0119 5.25v9.5A2.25 2.25 0 0116.75 17H3.25A2.25 2.25 0 011 14.75v-9.5zm1.5 5.81v3.69c0 .414.336.75.75.75h13.5a.75.75 0 00.75-.75v-2.69l-2.22-2.219a.75.75 0 00-1.06 0l-1.91 1.909.47.47a.75.75 0 11-1.06 1.06L6.53 8.091a.75.75 0 00-1.06 0l-2.97 2.97zM12 7a1 1 0 11-2 0 1 1 0 012 0z"
                                            clip-rule="evenodd" />
                                    </svg>

                                    <h5 class="text-gray-500">
                                        {{ $t('versodelacnidelacheteur') }}
                                    </h5>
                                    <p class="text-xs text-gray-400 mt-1">{{ $t('taillecni') }}</p>
                                </div>
                                <div v-if="previewverso.length != 0"
                                    class="text-center h-full flex justify-center items-center absolute top-0 right-0 left-0 m-auto">
                                    <img :src="previewverso" class="h-full w-full object-cover object-center" alt="">
                                    <span class="absolute bottom-2 rounded bg-black/70 px-3 py-1 text-xs text-white">{{ $t('remplacerimage') }}</span>
                                </div>
                            </div>

                            <div class="border border-dashed border-gray-500 w-full relative">
                                <input ref="acheteurRectoInput" @change="imgAcheterRecto" type="file" accept="image/jpeg,image/jpg,image/png,image/gif,image/webp" capture="environment"
                                    class="cursor-pointer relative block opacity-0 w-full h-full p-20 z-50">
                                <div v-if="previewrecto.length == 0"
                                    class="text-center h-full flex flex-col justify-center items-center absolute top-0 right-0 left-0 m-auto">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                        class="w-10 h-10 text-gray-500">
                                        <path fill-rule="evenodd"
                                            d="M1 5.25A2.25 2.25 0 013.25 3h13.5A2.25 2.25 0 0119 5.25v9.5A2.25 2.25 0 0116.75 17H3.25A2.25 2.25 0 011 14.75v-9.5zm1.5 5.81v3.69c0 .414.336.75.75.75h13.5a.75.75 0 00.75-.75v-2.69l-2.22-2.219a.75.75 0 00-1.06 0l-1.91 1.909.47.47a.75.75 0 11-1.06 1.06L6.53 8.091a.75.75 0 00-1.06 0l-2.97 2.97zM12 7a1 1 0 11-2 0 1 1 0 012 0z"
                                            clip-rule="evenodd" />
                                    </svg>

                                    <h5 class="text-gray-500">
                                        {{ $t('rectodelacnidelacheteur') }}
                                    </h5>
                                    <p class="text-xs text-gray-400 mt-1">{{ $t('taillecni') }}</p>

                                </div>
                                <div v-if="previewrecto.length != 0"
                                    class="text-center h-full flex justify-center items-center absolute top-0 right-0 left-0 m-auto">
                                    <img :src="previewrecto" class="h-full w-full object-cover object-center" alt="">
                                    <span class="absolute bottom-2 rounded bg-black/70 px-3 py-1 text-xs text-white">{{ $t('remplacerimage') }}</span>
                                </div>
                            </div>
                        </div>
                        <p v-if="!canSubmitBuyerCni" class="w-[95%] text-center text-sm text-red-500">{{ $t('messageerrorrectoversoacheteur') }}</p>
                        <div class=" space-x-2 flex justify-around items-center">
                            <button v-if="loadingLivraison == false" type="submit" @click="validatedCommande" :disabled="!canSubmitBuyerCni"
                                :class="['py-2 px-5 text-white rounded', canSubmitBuyerCni ? 'bg-green-500' : 'bg-gray-300 cursor-not-allowed']">{{$t('validez')}}</button>
                            <button v-if="loadingLivraison == false" type="button" @click="closeValidate"
                                class="py-2 px-5 bg-red-500 text-white rounded">{{$t('annuler')}}</button>
                            <div v-if="loadingLivraison == true"
                                class="animate-spin ease-linear rounded-full w-10 h-10 border-t-2 border-b-2 border-orange-500">
                            </div>
                        </div>
                    </div>
                </div>
                <div @click="closeValidate" class="w-full  h-full "></div>
            </div>
        </div>

        <!-- showValidate -->
        <div id="previewpage" class="flex w-full  h-full">
            <div class=""></div>
            <div class="h-full  w-full flex-shrink-0  relative transition-next le">
                <div v-if="user" class="h-full w-full relative">
                    <div class="h-[10%] bg-[#F8F8F8] w-full flex items-center">
                        <div class="w-full justify-between md:px-3 flex mt-1">
                            <div class="flex justify-between items-center md:justify-normal w-full md:w-auto">
                                <div class="flex  space-x-2 px-2 md:px-4  md:border-r-[1px] border-gray-300">
                                    <div class="h-auto  flex   overflow-hidden   items-center justify-center">
                                        <img v-if="user.avatar" class="w-10 rounded-full h-10 object-cover object-center "
                                            :src="$avatarImage(user, 'profile')" alt="" srcset="">
                                        <img v-if="user.avatar == '' || user.avatar == null"
                                            class="w-7 h-7 mx-auto object-cover object-center  "
                                            src="/logo/mel_logo_all_fond.png" alt="" srcset="">
                                    </div>
                                    <div class="h-auto flex flex-col justify-start items-center">
                                        <div class="h-auto">
                                            <p class=" font-semibold">
                                                <span>{{ $t('caissier') }}: </span> {{ user.name }}
                                            </p>
                                        </div>
                                        <div class="flex w-full ">
                                            <!-- etoiles -->
                                            <span>{{ $t('pointderelais') }}: </span> {{ user.relai.numero }}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div v-if="showNotifications" @click="showNotifications = false"
                                class="fixed inset-0 z-40"></div>
                            <div class="flex space-x-2 items-center">
                                <div class="relative z-50">
                                    <button @click="toggleNotifications" type="button"
                                        class="relative flex h-9 w-9 items-center justify-center rounded-full bg-white shadow transition hover:bg-orange-50"
                                        aria-label="Notifications">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                                            fill="none" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round"
                                            class="h-5 w-5 text-gray-700">
                                            <path d="M18 8a6 6 0 0 0-12 0c0 7-3 7-3 7h18s-3 0-3-7" />
                                            <path d="M13.73 21a2 2 0 0 1-3.46 0" />
                                        </svg>
                                        <span v-if="notificationsnonlu > 0"
                                            class="absolute -right-1 -top-1 flex min-w-[1.15rem] items-center justify-center rounded-full bg-red-500 px-1 text-[0.6rem] font-semibold text-white">
                                            {{ notificationsnonlu > 99 ? '99+' : notificationsnonlu }}
                                        </span>
                                    </button>
                                    <div v-if="showNotifications"
                                        class="absolute right-0 top-11 z-50 w-80 max-w-[90vw] overflow-hidden rounded-lg border border-gray-200 bg-white shadow-xl">
                                        <div class="flex items-center justify-between border-b px-4 py-3">
                                            <p class="text-sm font-semibold text-gray-800">Notifications</p>
                                            <button type="button" @click="showNotifications = false"
                                                class="text-lg leading-none text-gray-400 hover:text-gray-700">x</button>
                                        </div>
                                        <notification-caisse-component :unread-count="notificationsnonlu"
                                            @read="markNotificationsRead" />
                                    </div>
                                </div>
                                <div 
                                    class="z-50 w-[5.5rem]  xl:px-1">
                                    <button v-if="langue == 'fr'" @click='changeLangue()' type="button"
                                        class=" flex items-center w-full h-full space-x-1 ">
                                        <img class="w-6 h-6 " src="/icons/england_480px.png" alt="" srcset="">
                                        <p class="mb-1">Anglais</p>
                                    </button>
                                    <button v-if="langue == 'en'" @click='changeLangue()' type="button"
                                        class=" flex items-center w-full h-full space-x-1 ">
                                        <img class="w-6 h-6 " src="/icons/france_480px.png" alt="" srcset="">
                                        <p class="mb-1">Français</p>
                                    </button>
                                </div>
                                <div @click="logout" class="w-9 h-auto flex  items-center">
                                    <img class="w-full h-9" src="/icons/shutdow.png" alt="" srcset="">
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="h-[90%] w-full flex">
                        <div class="h-full xl:w-[18%] bg-[#FF9900]  relative link">
                            <div class="w-full absolute bottom-0 px-2 xl:px-0 flex space-x-2">
                                <div class="w-[90%] mx-auto flex">
                                    <img class="h-8 md:h-9" src="/logo/logo_mel_completement_blanc.png" alt="" srcset="">
                                    <div class="h-auto flex items-center">
                                        <p class="text-white hidden xl:block text-sm mt-2">{{ $t('membredepuis') }} {{
                                            JSON.parse($t('mois'))[new Date(user.created_at).getMonth()] }} {{ new
        Date(user.created_at).getFullYear() }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="w-full cursor-pointer xl:h-[12%] h-[8%] mt-2 md:mt-0 flex">
                                <router-link to="MesCommandes" class="w-full flex xl:block px-3 h-full mx-auto">
                                    <div class=" h-full flex mx-auto items-center space-x-4">
                                        <img class="md:h-7 h-5 object-contain" src="/icons/icons8_shopping_basket@2x.png"
                                            alt="" srcset="">
                                        <p class="text-white hidden xl:block text-lg">{{ $t('mescommandes') }}</p>
                                    </div>
                                </router-link>
                            </div>
                            <div class="w-full cursor-pointer xl:h-[12%] h-[8%] flex">
                                <router-link to="/jours-feries" class="w-full flex xl:block px-3 h-full mx-auto"
                                    :aria-label="langue === 'en' ? 'Public holidays' : 'Jours fériés'">
                                    <div class="h-full flex mx-auto items-center space-x-4">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                                            stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round" class="md:h-7 md:w-7 h-5 w-5 flex-shrink-0 text-white">
                                            <path d="M8 2v4" />
                                            <path d="M16 2v4" />
                                            <rect width="18" height="18" x="3" y="4" rx="2" />
                                            <path d="M3 10h18" />
                                            <path d="m9 16 2 2 4-4" />
                                        </svg>
                                        <p class="text-white hidden xl:block text-lg">
                                            {{ langue === 'en' ? 'Public holidays' : 'Jours fériés' }}
                                        </p>
                                    </div>
                                </router-link>
                            </div>
                        </div>
                        <div class="h-full w-full xl:w-[82%] overflow-hidden">
                            <router-view name="two"></router-view>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
// import { CircleProgressBar } from 'vue3-m-circle-progress-bar';
// import '@vuepic/vue-datepicker/dist/main.css'
import DetailPage from "../DetailPageComponent.vue";
import FacturePage from "../FactureComponent.vue";
import NotificationCaisseComponent from "./NotificationCaisseComponent.vue";
import { registerPushNotifications } from "../../js/pushNotifications";
import { clearAppBadgeAndNotifications, syncAppBadge } from "../../js/appBadge";

export default {
    components: { DetailPage, FacturePage, NotificationCaisseComponent },
    data() {
        return {
            user: '',
            article: '',
            loadingScreen: true,
            showDetail: false,
            facture: '',
            showRecu: false,
            showValidate: false,
            showReceive: false,
            showCanceledCommandeRecuperation: false,
            etape: 1,
            saveLoading: '',
            loadingRecuperation: false,
            loadingLivraison: false,
            loadingAnnulationCommandeRecuperation: false,
            langue: '',
            form: {
                sexe: 'Homme',
                ville: '',
                description: '',
                date_naissance: '',
                avatar: '',
                quartier: '',
                mon_pays: 'Cameroun'
            },
            formAnnulation: {
                raison_fr: '',
                raison_en: ''
            },
            villes: [],
            error: '',
            avatarSelect: '',
            flow: ['year', 'month', 'calendar'],
            PhotosAcheteurs: {
                verso: '',
                recto: ''
            },
            previewverso: "",
            previewrecto: "",
            PhotosVendeurs: {
                verso: '',
                recto: ''
            },
            Venverso: "",
            Venrecto: "",
            erreurAlert: '',
            messageErreurAlert: '',
            successAlert: '',
            messageSuccessAlert: '',
            hidlangue: false,
            factureRecu: null,
            showNotifications: false,
            notificationsnonlu: 0,
            notificationMusic: null,
            showPushPermissionModal: false,
            pushPermissionLoading: false,
        }
    },
    watch: {
        requestAccueil: {
            handler(newValue) {
                this.user = newValue[0]
            },
            deep: true
        },
    },

    beforeRouteLeave() {
        window.emitter.off("hideAndShow");
        window.emitter.off("OpenRecu");
        window.emitter.off("openReceive");
        window.emitter.off("openValidate");
        window.emitter.off("openCanceledCommandRecuperation");
    },

    created() {
        window.emitter.on("hideAndShow", (data) => {
            this.showDetail = data[1]
            this.article = data[0]
        })
        window.emitter.on("OpenRecu", (data) => {
            this.showRecu = data[1]
            this.facture = data[0]
        })
        window.emitter.on("openReceive", (data) => {
            this.showReceive = data[1]
            this.facture = data[0]
        })
        window.emitter.on("openValidate", (data) => {
            this.showValidate = data[1]
            this.facture = data[0]
        })
        window.emitter.on("openCanceledCommandRecuperation", (data) => {
            this.showCanceledCommandeRecuperation = data[1]
            this.facture = data[0]
        })

        window.emitter.on("alertError", (data) => {
            this.music = new Audio(
                "/music/error.mp3"
            )
            this.music.autoplay = true
            this.erreurAlert = data[0]
            this.messageErreurAlert = data[1]
            setTimeout(() => {
                this.erreurAlert = ''
            }, 8000);
        })
        window.emitter.on("alertSucces", (data) => {
            this.music = new Audio(
                "/music/notification.mp3"
            )
            this.music.autoplay = true
            this.successAlert = data[0]
            this.messageSuccessAlert = data[1]
            setTimeout(() => {
                this.successAlert = ''
            }, 8000);
        })

    },
    mounted() {
        if (localStorage.getItem('langue') == null || localStorage.getItem('langue') == '' || localStorage.getItem('langue') == false) {
            localStorage.setItem('langue', 'fr')
        }

        if (localStorage.getItem('langue') != 'en') {
            this.$i18n.locale = 'fr'
        } else {
            this.$i18n.locale = 'en'
        }

        if (localStorage.getItem('langue')) {
            this.langue = localStorage.getItem('langue');
        }

        this.axios.get(this.requestHttp + 'infos-point-relai', {
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem("jwtToken")
            }
        }).then(({ data }) => {
            this.user = data[0]
            if(!this.user.relai){
                localStorage.removeItem('jwtToken')
                this.$router.push('/')
            }
            this.loadingScreen = false;
            this.$store.state.dataAccueil = data
            this.loadNotificationsCount()
            this.listenUserNotifications()
            this.preparePushPermission()
            window.Echo.channel('commande.' + this.user.relai.id)
            .listen('EventCaissiere.EventCommande', (e) => {
                if (this.$store.state.factures.length > 0) {
                    this.$store.state.factures.filter((item, index) => item.id == e['commande'].id ? (this.$store.state.factures.splice(index, 1)) : '')
                    this.$store.state.factures.unshift(e['commande']);
                }
                if (e['commande'].status == 'en cour livraison') {
                    if (this.$store.state.facturesEnCoursLivraison.length > 0) {
                        this.$store.state.facturesEnCoursLivraison.unshift(e['commande']);
                    }
                    this.$store.state.nbrEnCourLivraisonCommande += 1;
                }
                if (e['commande'].status == 'en cour recuperation') {
                    this.$store.state.facturesEnCoursLivraison.filter((item, index) => item.id == e['commande'].id ? (this.$store.state.facturesEnCoursLivraison.splice(index, 1)) : '')
                    if (this.$store.state.facturesEnCoursRecuperation.length > 0) {
                        this.$store.state.facturesEnCoursRecuperation.unshift(e['commande']);
                    }
                    this.$store.state.nbrEnCourLivraisonCommande = Math.max(0, this.$store.state.nbrEnCourLivraisonCommande - 1);
                    this.$store.state.nbrEnCourRecuperationCommande += 1;
                }

                if (e['commande'].status == 'annule') {
                    this.$store.state.facturesEnCoursLivraison.filter((item, index) => item.id == e['commande'].id ? (this.$store.state.facturesEnCoursLivraison.splice(index, 1), this.$store.state.nbrEnCourLivraisonCommande = Math.max(0, this.$store.state.nbrEnCourLivraisonCommande - 1)) : '')
                    this.$store.state.facturesEnCoursRecuperation.filter((item, index) => item.id == e['commande'].id ? (this.$store.state.facturesEnCoursRecuperation.splice(index, 1), this.$store.state.nbrEnCourRecuperationCommande = Math.max(0, this.$store.state.nbrEnCourRecuperationCommande - 1)) : '')
                    if (this.$store.state.facturesAnnule.length > 0) {
                        e['commande'].article.coupon = null
                        this.$store.state.facturesAnnule.unshift(e['commande']);
                    }
                    this.$store.state.nbrAnnuleCommande += 1;
                }

                if (e['commande'].status == 'valide') {
                    const recuperationIndex = this.$store.state.facturesEnCoursRecuperation.findIndex((item) => item.id == e['commande'].id)
                    if (recuperationIndex !== -1) {
                        this.$store.state.facturesEnCoursRecuperation.splice(recuperationIndex, 1)
                    }
                    if (this.$store.state.factureValide.length > 0) {
                        e['commande'].article.coupon = null
                        this.$store.state.factureValide.unshift(e['commande']);
                    }
                    this.$store.state.nbrEnCourRecuperationCommande = Math.max(0, this.$store.state.nbrEnCourRecuperationCommande - 1);
                    this.$store.state.nbrValideCommande += 1;
                }
            })

            window.Echo.channel('commande.' + this.user.relai.id)
            .listen('EventCaissiere.FactureExpirationProche', (e) => {
                if (e.facture?.type_alerte === 'vendeur_livraison') {
                    this.$store.commit('ajouterFactureLivraisonVendeurExpirante', e.facture)
                } else {
                    this.$store.commit('ajouterFactureExpirante', e.facture)
                }
            })
        }).catch(error => {
            console.log(error);
        })
    },
    beforeUnmount() {
        if (this.user?.relai?.id) {
            window.Echo.leave('commande.' + this.user.relai.id)
        }
        if (this.user?.id) {
            window.Echo.leave('App.Models.User.' + this.user.id)
        }
    },
    methods: {
        canUsePushNotifications() {
            return 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window
        },

        preparePushPermission() {
            if (!this.canUsePushNotifications()) return

            if (Notification.permission === 'granted') {
                registerPushNotifications(this.requestHttp, 'melcaisse')
                    .then(() => syncAppBadge(this.notificationsnonlu))
                    .catch(() => {})
                return
            }

            if (Notification.permission === 'denied') return

            const dismissedAt = Number(localStorage.getItem('melcaisse_push_permission_dismissed_at') || 0)
            const oneDay = 24 * 60 * 60 * 1000

            if (!dismissedAt || Date.now() - dismissedAt > oneDay) {
                this.showPushPermissionModal = true
            }
        },

        activatePushNotifications() {
            if (!this.canUsePushNotifications()) {
                this.showPushPermissionModal = false
                return
            }

            this.pushPermissionLoading = true
            registerPushNotifications(this.requestHttp, 'melcaisse')
                .then(() => {
                    localStorage.removeItem('melcaisse_push_permission_dismissed_at')
                    this.showPushPermissionModal = false
                    syncAppBadge(this.notificationsnonlu)
                })
                .finally(() => {
                    this.pushPermissionLoading = false
                })
        },

        dismissPushPermissionModal() {
            localStorage.setItem('melcaisse_push_permission_dismissed_at', Date.now().toString())
            this.showPushPermissionModal = false
        },

        toggleNotifications() {
            this.showNotifications = !this.showNotifications
        },

        markNotificationsRead() {
            this.notificationsnonlu = 0
            this.$store.state.notificationsnonlu = 0
            clearAppBadgeAndNotifications()
        },

        loadNotificationsCount() {
            this.axios.get(this.requestHttp + 'notifications-count', {
                headers: {
                    'Authorization': 'Bearer ' + localStorage.getItem("jwtToken")
                }
            }).then(({ data }) => {
                this.notificationsnonlu = data.count || 0
                this.$store.state.notificationsnonlu = this.notificationsnonlu
                syncAppBadge(this.notificationsnonlu)
            })
        },

        listenUserNotifications() {
            if (!this.user?.id) return

            window.Echo.private('App.Models.User.' + this.user.id).notification((notification) => {
                const item = [
                    { id: notification.id, data: JSON.stringify(notification.data), read_at: null },
                    { en: notification.en, fr: notification.fr }
                ]

                if (notification.id) {
                    this.$store.state.notifications = this.$store.state.notifications.filter(notificationItem => notificationItem[0]?.id != notification.id)
                }
                this.$store.state.notifications.unshift(item)
                this.notificationsnonlu += 1
                this.$store.state.notificationsnonlu = this.notificationsnonlu
                syncAppBadge(this.notificationsnonlu)

                this.notificationMusic ? this.notificationMusic.pause() : ''
                this.notificationMusic = new Audio("/music/notification.mp3")
                this.notificationMusic.autoplay = true
            })
        },

        closeReceive() {
            this.showReceive = false
            this.resetVendorCni()
        },
        closeValidate() {
            this.showValidate = false
            this.resetBuyerCni()
        },

        resetBuyerCni() {
            this.PhotosAcheteurs.verso = ''
            this.PhotosAcheteurs.recto = ''
            this.previewverso = ''
            this.previewrecto = ''
            if (this.$refs.acheteurVersoInput) this.$refs.acheteurVersoInput.value = ''
            if (this.$refs.acheteurRectoInput) this.$refs.acheteurRectoInput.value = ''
        },

        resetVendorCni() {
            this.PhotosVendeurs.verso = ''
            this.PhotosVendeurs.recto = ''
            this.Venverso = ''
            this.Venrecto = ''
            if (this.$refs.vendeurVersoInput) this.$refs.vendeurVersoInput.value = ''
            if (this.$refs.vendeurRectoInput) this.$refs.vendeurRectoInput.value = ''
        },

        changeLangue() {
            this.hidlangue = false
            localStorage.setItem('langue', this.langue)

            if (this.langue == 'fr') {
                this.langue = 'en'
                localStorage.setItem('langue', this.langue)
            } else {
                this.langue = 'fr'
                localStorage.setItem('langue', this.langue)
            }

            if (localStorage.getItem('langue') != 'en') {
                this.$i18n.locale = 'fr'
            } else {
                this.$i18n.locale = 'en'
            }
        },

        async imgAcheterVerso(e) {
            let fileCompress = await this.$compressImage(e.target.files[0]);
            const image = fileCompress;
            this.PhotosAcheteurs.verso = fileCompress;
            const reader = new FileReader();
            reader.readAsDataURL(image);
            reader.onload = e => {
                this.previewverso = e.target.result;
            };
        },

        async imgVendeurVerso(e) {
            let fileCompress = await this.$compressImage(e.target.files[0]);
            const image = fileCompress;
            this.PhotosVendeurs.verso = fileCompress;
            const reader = new FileReader();
            reader.readAsDataURL(image);
            reader.onload = e => {
                this.Venverso = e.target.result;
            };
        },

        async imgVendeurRecto(e) {
            let fileCompress = await this.$compressImage(e.target.files[0]);
            const image = fileCompress;
            this.PhotosVendeurs.recto = fileCompress;
            const reader = new FileReader();
            reader.readAsDataURL(image);
            reader.onload = e => {
                this.Venrecto = e.target.result;
            };
        },

        async imgAcheterRecto(e) {
            let fileCompress = await this.$compressImage(e.target.files[0]);
            const image = fileCompress;
            this.PhotosAcheteurs.recto = fileCompress;
            const reader = new FileReader();
            reader.readAsDataURL(image);
            reader.onload = e => {
                this.previewrecto = e.target.result;
            };
        },


        validatedCommande() {
            this.loadingLivraison = true
            // valide une commande
            if (this.PhotosAcheteurs.recto && this.PhotosAcheteurs.verso) {
                this.showValidate = false
                this.showRecu = true

                // Copie locale, isolée du store : évite toute mutation prématurée de this.facture
                this.factureRecu = {
                    ...this.facture,
                    montant_verse: this.facture.montant_total
                }

                this.$nextTick(() => {
                    var docFac = document.getElementById("facture");

                    var btnPrint = document.getElementById("btn-print");
                    docFac.removeChild(btnPrint);

                    docFac.firstElementChild.classList.replace("max-h-[95vh]", "max-h-max")

                    // Supprimer contraintes responsive
                    docFac.firstElementChild.classList.remove("w-[95vw]");
                    docFac.firstElementChild.classList.remove("max-w-xl");
                    docFac.firstElementChild.classList.remove("mx-auto");

                    // Largeur FIXE pour PDF Letter avec margin:1
                    docFac.firstElementChild.style.width = "6in";
                    docFac.firstElementChild.style.margin = "0 auto";
                    docFac.firstElementChild.style.maxWidth = "none";

                    docFac.firstElementChild.classList.remove("overflow-y-auto")

                    window.emitter.emit("OpenFacture", {
                        etape: 1,
                        message: this.$i18n.messages[`${localStorage.getItem('langue')}`].recuencourdecreation
                    })

                    var opt = {
                        margin: 1,
                        filename: 'myfile.pdf',
                        image: { type: 'jpeg', quality: 0.98 },
                        html2canvas: { scale: 2 },
                        jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
                    };

                    html2pdf().from(docFac).set(opt).toPdf().output('blob').then((result) => {
                        window.emitter.emit("OpenFacture", {
                            etape: 2,
                            message: this.$i18n.messages[`${localStorage.getItem('langue')}`].recuencourdenvoie
                        })
                        var data = new FormData();
                        data.append("id", this.facture.id);
                        data.append("img_cni_acheteur_verso", this.PhotosAcheteurs.verso);
                        data.append("img_cni_acheteur_recto", this.PhotosAcheteurs.recto);
                        data.append("file", result);

                        this.axios.post(this.requestHttp + "commande-success", data, {
                            headers: {
                                'Authorization': 'Bearer ' + localStorage.getItem("jwtToken")
                            }
                        }).then(({ data }) => {
                            // Succès confirmé par le backend : ici seulement on synchronise l'état réel
                            this.loadingLivraison = false
                            this.showRecu = false
                            this.factureRecu = null
                            this.resetBuyerCni()

                            window.emitter.emit("alertSucces", ['Recuperation', this.$i18n.messages[`${localStorage.getItem('langue')}`].recuperationvalidee])

                            this.$store.state.factures.filter((item, index) => item.id == data[0].id ? (this.$store.state.factures.splice(index, 1)) : '')
                            this.$store.state.factures.unshift(data[0]);
                            if (this.$store.state.factureValide.length > 0) {
                                this.$store.state.factureValide.unshift(data[0])
                            }
                            this.$store.state.nbrValideCommande += 1;
                            this.$store.state.nbrEnCourRecuperationCommande = Math.max(0, this.$store.state.nbrEnCourRecuperationCommande - 1);
                            this.$store.state.facturesEnCoursRecuperation.filter((item, index) => item.id == data[0].id ? (this.$store.state.facturesEnCoursRecuperation.splice(index, 1)) : '')

                        }).catch(error => {
                            // Échec (solde insuffisant, erreur interne, etc.) :
                            // this.facture n'a jamais été modifié, donc rien à restaurer, aucune désynchronisation possible
                            this.showRecu = false
                            this.loadingLivraison = false;
                            this.resetBuyerCni()
                            this.factureRecu = null

                            if (error.response?.data?.message == 'solde insuffisant') {
                                window.emitter.emit("alertError", ['solde insuffisant', this.$i18n.messages[`${localStorage.getItem('langue')}`].soldeacheteurinsuffissant])
                            }
                            if (!error.response?.data?.message || error.response?.data?.message == 'Erreur interne, veuillez réessayer') {
                                window.emitter.emit("alertError", ['Erreur interne, veuillez réessayer', this.$i18n.messages[`${localStorage.getItem('langue')}`].erreurlorsduprocessusdevalidationdelacommande])
                            }
                        })
                    })
                })
            } else {
                this.loadingLivraison = false;
                window.emitter.emit("alertError", ['erreur cni', this.$i18n.messages[`${localStorage.getItem('langue')}`].messageerrorrectoversoacheteur])
            }
        },

        recuperationCommande() {
            this.loadingRecuperation = true;
            if (this.PhotosVendeurs.recto && this.PhotosVendeurs.verso) {
                let data = new FormData();
                data.append("id", this.facture.id);
                data.append("nom_domain", this.linkmail);
                data.append("img_cni_vendeur_verso", this.PhotosVendeurs.verso);
                data.append("img_cni_vendeur_recto", this.PhotosVendeurs.recto);
                this.axios.post(this.requestHttp + "article-commande-recu", data, {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem("jwtToken"),
                    }
                }).then(({ data }) => {
                    window.emitter.emit("alertSucces", ['Recuperation en cour', this.$i18n.messages[`${localStorage.getItem('langue')}`].recuperationvalidee])
                    this.loadingRecuperation = false;
                    this.resetVendorCni()
                    this.showReceive = false;
                    this.$store.state.factures.filter((item, index) => item.id == data[0].id  ? (this.$store.state.factures.splice(index, 1)) : '')
                    this.$store.state.factures.unshift(data[0]);
                    if (this.$store.state.facturesEnCoursRecuperation.length > 0) {
                        this.$store.state.facturesEnCoursRecuperation.unshift(data[0])
                    }
                    this.$store.state.nbrEnCourLivraisonCommande = Math.max(0, this.$store.state.nbrEnCourLivraisonCommande - 1);
                    this.$store.state.nbrEnCourRecuperationCommande += 1;
                    this.$store.state.facturesEnCoursLivraison.filter((item, index) => item.id == data[0].id ? (this.$store.state.facturesEnCoursLivraison.splice(index, 1)) : '')

                }).catch(error => {
                    this.loadingRecuperation = false;
                    window.emitter.emit("alertError", ['Recuperation', error.response?.data?.message || 'Erreur lors de la recuperation'])
                })
            } else {
                this.loadingRecuperation = false;
                window.emitter.emit("alertError", ['erreur cni', this.$i18n.messages[`${localStorage.getItem('langue')}`].messageerrorrectoversovendeur])
            }
        },

        annulationCommandeRecuperation(facteur){
            this.loadingAnnulationCommandeRecuperation = true;
            this.axios.post(this.requestHttp + "annuler-commande-recuperation/" + facteur.id, this.formAnnulation, {
                headers: {
                    'Authorization': 'Bearer ' + localStorage.getItem("jwtToken")
                }
            }).then(({ data }) => {
                const factureAnnulee = data[0] || data
                this.loadingAnnulationCommandeRecuperation = false;
                this.$store.state.facturesEnCoursLivraison.filter((item, index) => item.id == factureAnnulee.id ? (this.$store.state.facturesEnCoursLivraison.splice(index, 1), this.$store.state.nbrEnCourLivraisonCommande = Math.max(0, this.$store.state.nbrEnCourLivraisonCommande - 1)) : '')
                this.$store.state.facturesEnCoursRecuperation.filter((item, index) => item.id == factureAnnulee.id ? (this.$store.state.facturesEnCoursRecuperation.splice(index, 1), this.$store.state.nbrEnCourRecuperationCommande = Math.max(0, this.$store.state.nbrEnCourRecuperationCommande - 1)) : '')
                if (this.$store.state.facturesAnnule.length > 0) {
                    if (factureAnnulee.article) {
                        factureAnnulee.article.coupon = null
                    }
                    this.$store.state.facturesAnnule.unshift(factureAnnulee);
                }
                this.$store.state.nbrAnnuleCommande += 1;
                this.formAnnulation.raison_fr = ''
                this.formAnnulation.raison_en = ''
                this.showCanceledCommandeRecuperation = false
                window.emitter.emit("alertSucces", ['Annulation', this.$i18n.messages[`${localStorage.getItem('langue')}`].commandeannulee || 'Commande annulée'])

            }).catch(error => {
                this.loadingAnnulationCommandeRecuperation = false;
                window.emitter.emit("alertError", ['Annulation', error.response?.data?.message || 'Erreur lors de l’annulation'])
            })
        },

        logout() {
            localStorage.removeItem("jwtToken");
            clearAppBadgeAndNotifications()
            this.$router.push('/')
        }
    },
    computed: {
        requestHttp() {
            return this.$store.state.api
        },
        requestAccueil() {
            return this.$store.state.dataAccueil
        },
        requestFile() {
            return this.$store.state.apifile;
        },

        linkmail() {
            return this.$store.state.linkMail;
        },

        canSubmitBuyerCni() {
            return Boolean(this.PhotosAcheteurs.recto && this.PhotosAcheteurs.verso)
        },

        canSubmitVendorCni() {
            return Boolean(this.PhotosVendeurs.recto && this.PhotosVendeurs.verso)
        }
    }
}
</script>

<style>
.link .router-link-active {
    background-color: rgb(180 109 2 / var(--tw-bg-opacity));
    color: #FF9900;
}

:root {
    --tx: 0;
    --ty: 0;
}

.transition-next {
    animation: transitLeft 3s;
    transform: translateX(var(--ty));
}

@keyframes transitLeft {
    0% {
        transform: translateX(0)
    }

    100% {
        transform: translateX(var(--ty))
    }
}

.preview-transition {
    animation: transitRight 3s;
    transform: translateX(var(--ty))
}

@keyframes transitRight {
    0% {
        transform: translateX(0)
    }

    100% {
        transform: translateX(var(--ty))
    }
}

/* loading */
#page {
    display: flex;
    justify-content: center;
    align-items: center;
}

#container {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
}

#h3 {
    color: rgb(82, 79, 79);
}

#ring {
    width: 190px;
    height: 190px;
    border: 1px solid transparent;
    border-radius: 50%;
    position: absolute;
}

#ring:nth-child(1) {
    border-bottom: 8px solid rgb(81, 255, 0);
    animation: rotate1 2s linear infinite;
}

@keyframes rotate1 {
    from {
        transform: rotateX(50deg) rotateZ(110deg);
    }

    to {
        transform: rotateX(50deg) rotateZ(470deg);
    }
}

#ring:nth-child(2) {
    border-bottom: 8px solid rgb(240, 19, 67);
    animation: rotate2 2s linear infinite;
}

@keyframes rotate2 {
    from {
        transform: rotateX(20deg) rotateY(50deg) rotateZ(20deg);
    }

    to {
        transform: rotateX(20deg) rotateY(50deg) rotateZ(380deg);
    }
}

#ring:nth-child(3) {
    border-bottom: 8px solid rgb(255, 255, 0);
    animation: rotate3 2s linear infinite;
}

@keyframes rotate3 {
    from {
        transform: rotateX(40deg) rotateY(130deg) rotateZ(450deg);
    }

    to {
        transform: rotateX(40deg) rotateY(130deg) rotateZ(90deg);
    }
}

#ring:nth-child(4) {
    border-bottom: 8px solid rgb(255, 170, 14);
    animation: rotate4 2s linear infinite;
}

@keyframes rotate4 {
    from {
        transform: rotateX(70deg) rotateZ(270deg);
    }

    to {
        transform: rotateX(70deg) rotateZ(630deg);
    }
}

.scrollbar-hide::-webkit-scrollbar {
    display: none;
}

/* For IE, Edge and Firefox */
.scrollbar-hide {
    -ms-overflow-style: none;
    /* IE and Edge */
    scrollbar-width: none;
    /* Firefox */
}
</style>
